import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './right-side.vue';

// Websockets
import { WebsocketsListener } from '../../utils/ws'

import RightSideLotsList from '../right-side-lots-list/index';
import RightSideItemContent from '../right-side-item-content/index';
import RightSideAlertNotCurrentLot from '../right-side-alert-not-current-lot/index';

@Component({
    mixins: [template],
    components: {
        RightSideLotsList,
        RightSideItemContent,
        RightSideAlertNotCurrentLot
    }
})

export default class RightSide extends Vue {

    @Prop(Object) readonly auctionDataParent!: object;
    @Prop(Object) readonly wsListener!: WebsocketsListener;

    created() {
        // When the component gets created.
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/right-side/index.ts